import React, { Component } from "react";

class MobFooterNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      home: true,
      isSearch: false,
      isManageBooking: false,
    };
  }

  onClickHome = () => {
    window.location.href = "/";
    this.setState({
      home: true,
      isSearch: false,
      isManageBooking: false,
    });
  };

  onClickSearch = () => {
    if (window.location.pathname != "/") {
      this.onClickHome();
    } else {
      window.scrollTo(0, 0);
      this.setState({
        home: false,
        home: true,
        isManageBooking: false,
      });
    }
  };

  handleManageBooking = () => {
    this.setState({
      home: false,
      isSearch: false,
      isManageBooking: true,
    });
  };

  render() {
    const isMobile = this.props.data?.isMobile;
    const validPaths = ["/registration", "/vendor", "/myprofile", "/vendorreview"]; // "/vendorsubscription"
    const pathname = validPaths.includes(window.location.pathname);
    const styles = this.props.data.styles[1];
    const userLogin = this.props.data.user;
    const login = Object.keys(userLogin).length;
    return isMobile && pathname ? null : (
      <footer className={styles.mobile_footer}>
        <div className={styles.mb_navigation}>
          <div className={styles.mb_navigation__items}>
            <div
              className={`${styles.mb_navigation__item} ${styles.mb_navigation__item_active}`}
              onClick={this.onClickHome}
            >
              <div className={styles.mb_navigation__icon}>
                <img src="images/te_mob_home.svg" alt="Home" />
              </div>
              <span className={styles.mb_navigation__label}>Home</span>
            </div>
            <div className={styles.mb_navigation__item}>
              <div
                className={styles.mb_navigation__icon}
                onClick={() => (window.location.href = "/tourpackages")}
              >
                <img src="images/te_holiday.svg" alt="Holidays" />
              </div>
              <span className={styles.mb_navigation__label}>Holidays</span>
            </div>
            <div
              className={styles.mb_navigation__item}
              onClick={() => (window.location.href = "/holiday/tourmaster")}
            >
              <div className={styles.mb_navigation__icon}>
                <img src="images/te_tour_master_icon.svg" alt="Tour Masters" />
              </div>
              <span className={styles.mb_navigation__label}>Tour Masters</span>
            </div>
            {login ? (
              <div className={styles.mb_navigation__item}>
                <div
                  className={styles.mb_navigation__icon}
                  onClick={() => (window.location.href = "/myprofile")}
                >
                  <img src="images/te_User_Account.svg" alt="Account" />
                </div>
                <span className={styles.mb_navigation__label}>Account</span>
              </div>
            ) : null}
          </div>
        </div>
      </footer>
    );
  }
}

export default MobFooterNavbar;
